"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importDefault(require("react"));
var main_1 = require("./screens/main");
var App = function () {
    return react_1.default.createElement(main_1.MainScreen, null);
    // return <MainTestScreen />;
};
exports.App = App;
